// adapterPresets.js — Quick-fill model lists for popular built-ins.
//
// Source of truth for the ModelMultiSelect dropdown in AdapterSheet —
// pre-populated list of models per provider, with the ability to add
// custom ones (combobox pattern). Sprint v8.3 — expandido pra TODOS os
// 33 adapters do catalog (texto/imagem/vídeo/áudio) com lineup completo
// atualizado. Revisado 2026-08-02 contra docs oficiais dos provedores.
//
// Names DEVEM bater 1:1 com llmAdapterCatalog.js (name field).
//
// Quando o adapter não está nesta lista, ModelMultiSelect cai pro custom
// add only — user digita manualmente.

export const ADAPTER_PRESETS = {
  // ============================================================
  // TEXTO (19 adapters)
  // ============================================================

  'anthropic-api': {
    available_models: [
      'claude-sonnet-5-5',
      'claude-opus-5-5',
      'claude-fable-5-1',
      'claude-fable-5',
      'claude-mythos-5',
      'claude-opus-5',
      'claude-sonnet-5',
      'claude-opus-4-8',
      'claude-opus-4-7',
      'claude-opus-4-6',
      'claude-sonnet-4-6',
      'claude-sonnet-4-5',
      'claude-haiku-4-5',
    ],
    default_model: 'claude-sonnet-5-5',
  },

  'openai-api': {
    available_models: [
      'gpt-6-astra',
      'gpt-6-sol',
      'gpt-6-luna',
      'gpt-5.6-sol',
      'gpt-5.6',
      'gpt-5.6-terra',
      'gpt-5.6-luna',
      'gpt-5.5',
      'gpt-5.4',
      'gpt-5.4-mini',
      'gpt-5.4-nano',
      'gpt-4o',
      'gpt-4o-mini',
      'o3',
      'o3-mini',
      'o1',
    ],
    default_model: 'gpt-5.6-sol',
  },

  gemini: {
    // gemini-2.0 e gemini-1.5 descontinuados (Google AI Studio, jul/2026).
    available_models: [
      'gemini-3.6-flash',
      'gemini-3.5-flash',
      'gemini-3.5-flash-lite',
      'gemini-3.1-pro',
      'gemini-3.1-flash-lite',
      'gemini-2.5-pro',
      'gemini-2.5-flash',
      'gemini-2.5-flash-lite',
    ],
    default_model: 'gemini-3.6-flash',
  },

  deepseek: {
    // `deepseek-flash` é o ID oficial atual (V4.1 Flash). O V4 Flash
    // legado segue disponível apenas para sessões/configurações existentes.
    available_models: [
      'deepseek-flash',
      'deepseek-v4-pro',
      'deepseek-v4-flash',
      'deepseek-chat',
      'deepseek-reasoner',
    ],
    default_model: 'deepseek-flash',
  },

  openrouter: {
    available_models: [
      'anthropic/claude-opus-5',
      'anthropic/claude-mythos-5',
      'anthropic/claude-sonnet-5',
      'anthropic/claude-opus-4-8',
      'anthropic/claude-sonnet-4-6',
      'openai/gpt-5.6-sol',
      'openai/gpt-6-astra',
      'openai/gpt-6-sol',
      'openai/gpt-6-luna',
      'openai/gpt-5.6-terra',
      'openai/gpt-5.6-luna',
      'openai/gpt-5.5',
      'google/gemini-3.6-flash',
      'google/gemini-3.5-flash',
      'google/gemini-3.5-flash-lite',
      'google/gemini-2.5-pro',
      'deepseek/deepseek-flash',
      'deepseek/deepseek-v4-flash',
      'deepseek/deepseek-v4-pro',
      'x-ai/grok-4.5',
      'mistralai/mistral-medium-3-5',
      'mistralai/mistral-small-2603',
      'moonshotai/kimi-k3',
      'z-ai/glm-5.3',
      'z-ai/glm-5.2',
      'meta-llama/llama-3.3-70b-instruct',
      'qwen/qwen3.6-27b',
      'minimax/minimax-m3',
    ],
    default_model: 'anthropic/claude-sonnet-5',
  },

  xai: {
    available_models: [
      'grok-4.5',
      'grok-4.20',
      'grok-4',
      'grok-4-fast',
      'grok-3',
      'grok-3-mini',
    ],
    default_model: 'grok-4.5',
  },

  mistral: {
    // Mistral Medium 3.5 / Small 4 (docs.mistral.ai, jul/2026).
    // mistral-large-2411 e pixtral-large-2411 deprecados (mai/2026).
    available_models: [
      'mistral-medium-3-5',
      'mistral-small-2603',
      'mistral-large-3',
      'codestral-2508',
      'ministral-3-14b',
      'ministral-3-8b',
      'ministral-3-3b',
      'mistral-embed',
      'mistral-moderation-2603',
    ],
    default_model: 'mistral-medium-3-5',
  },

  qwen: {
    available_models: [
      'qwen3.7-max',
      'qwen3.7-plus',
      'qwen3.7-flash',
      'qwen3-coder-plus',
      'qwen3-coder-flash',
      'qwen3-vl-max',
      'qwq-max',
      'qwen2.5-72b-instruct',
      'qwen2.5-coder-32b-instruct',
    ],
    default_model: 'qwen3.7-flash',
  },

  groq: {
    // Atualizado via console.groq.com/docs/models (ago/2026). Produção:
    // Compound, Llama 3.3/3.1, GPT-OSS. Preview: qwen3.6-27b.
    // Removidos: llama-4, kimi-k2, deepseek-r1-distill, gemma2 (deprecated).
    available_models: [
      'groq/compound',
      'groq/compound-mini',
      'llama-3.3-70b-versatile',
      'llama-3.1-8b-instant',
      'openai/gpt-oss-120b',
      'openai/gpt-oss-20b',
      'qwen/qwen3.6-27b',
    ],
    default_model: 'llama-3.3-70b-versatile',
  },

  together: {
    available_models: [
      'meta-llama/Llama-3.3-70B-Instruct-Turbo',
      'meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo',
      'meta-llama/Meta-Llama-3.1-70B-Instruct-Turbo',
      'Qwen/Qwen2.5-Coder-32B-Instruct',
      'Qwen/Qwen2.5-72B-Instruct-Turbo',
      'Qwen/QwQ-32B-Preview',
      'deepseek-ai/DeepSeek-V3',
      'deepseek-ai/DeepSeek-R1',
      'mistralai/Mixtral-8x22B-Instruct-v0.1',
      'mistralai/Mistral-Small-24B-Instruct-2501',
      'nvidia/Llama-3.1-Nemotron-70B-Instruct-HF',
      'google/gemma-2-27b-it',
    ],
    default_model: 'meta-llama/Llama-3.3-70B-Instruct-Turbo',
  },

  ollama: {
    available_models: [
      'llama3.3',
      'llama3.3:70b',
      'llama3.2',
      'llama3.2:3b',
      'qwen2.5-coder',
      'qwen2.5-coder:32b',
      'deepseek-r1',
      'deepseek-r1:70b',
      'phi-4',
      'mistral',
      'codellama',
      'qwen2.5',
      'gemma2',
      'nemotron',
      'starcoder2',
    ],
    default_model: 'llama3.3',
  },

  // Atualizado 2026-08-02 com a lista oficial (platform.kimi.ai/docs/models.md):
  // kimi-k3 é o flagship; linha K2.7/K2.6 + moonshot-v1 (vision). K2 series
  // deprecada (mai/2026); kimi-k2.5 e moonshot-v1 em sunset para novos users.
  kimi: {
    available_models: [
      'kimi-k3',
      'kimi-k2.7-code',
      'kimi-k2.7-code-highspeed',
      'kimi-k2.6',
      'moonshot-v1-128k',
      'moonshot-v1-32k',
      'moonshot-v1-8k',
      'moonshot-v1-128k-vision-preview',
      'moonshot-v1-32k-vision-preview',
      'moonshot-v1-8k-vision-preview',
    ],
    default_model: 'kimi-k3',
  },

  // Atualizado 2026-08-31 com GLM-5.3 (docs.z.ai/guides/llm/glm-5.3):
  // flagship coding/agentic, 1M context, thinking always-on (low|high|max).
  // Mantém a linha 5.2/5.1/5/4.7/4.6 + 4.5 + multimodais 4.6v/5v.
  zai: {
    available_models: [
      'glm-5.3',
      'glm-5.2',
      'glm-5.1',
      'glm-5',
      'glm-5-turbo',
      'glm-4.7',
      'glm-4.7-flash',
      'glm-4.7-flashx',
      'glm-4.6',
      'glm-4.6v',
      'glm-4.6v-flash',
      'glm-4.6v-flashx',
      'glm-4.5',
      'glm-4.5-x',
      'glm-4.5-air',
      'glm-4.5-airx',
      'glm-4.5-flash',
      'glm-4.5v',
      'glm-5v-turbo',
      'glm-ocr',
      'glm-4-32b-0414-128k',
    ],
    default_model: 'glm-5.3',
  },

  minimax: {
    available_models: [
      'MiniMax-M3',
      'MiniMax-M2.7',
      'MiniMax-M2.7-highspeed',
      'MiniMax-M2.5',
    ],
    default_model: 'MiniMax-M3',
  },

  yi: {
    available_models: [
      'yi-lightning',
      'yi-large',
      'yi-large-turbo',
      'yi-large-fc',
      'yi-large-rag',
      'yi-medium',
      'yi-medium-200k',
      'yi-spark',
      'yi-vision',
    ],
    default_model: 'yi-lightning',
  },

  huggingface: {
    available_models: [
      'meta-llama/Llama-3.3-70B-Instruct',
      'meta-llama/Meta-Llama-3.1-405B-Instruct',
      'Qwen/Qwen2.5-72B-Instruct',
      'Qwen/Qwen2.5-Coder-32B-Instruct',
      'deepseek-ai/DeepSeek-V3',
      'deepseek-ai/DeepSeek-R1',
      'mistralai/Mistral-Large-Instruct-2411',
      'google/gemma-2-27b-it',
      'nvidia/Llama-3.1-Nemotron-70B-Instruct-HF',
    ],
    default_model: 'meta-llama/Llama-3.3-70B-Instruct',
  },

  'xiaomi-mimo': {
    available_models: ['mimo-7b-rl', 'mimo-7b-base'],
    default_model: 'mimo-7b-rl',
  },

  'claude-code-local': {
    available_models: [
      'claude-opus-5',
      'claude-sonnet-5',
      'claude-opus-4-8',
      'claude-sonnet-4-6',
    ],
    default_model: 'claude-sonnet-5',
  },

  fugu: {
    // Sakana Fugu — model-of-models; IDs exatos dependem de FUGU_BASE_URL.
    available_models: [],
    default_model: '',
  },

  'local-zip': {
    available_models: [],
    default_model: '',
  },

  // ============================================================
  // IMAGEM (5 adapters)
  // ============================================================

  'openai-dalle': {
    available_models: ['dall-e-3', 'dall-e-2'],
    default_model: 'dall-e-3',
  },

  ideogram: {
    available_models: [
      'ideogram-v3-turbo',
      'ideogram-v3',
      'ideogram-v2',
      'ideogram-v2-turbo',
      'ideogram-v1',
    ],
    default_model: 'ideogram-v3',
  },

  leonardo: {
    available_models: [
      'leonardo-phoenix',
      'leonardo-vision-xl',
      'leonardo-anime-xl',
      'leonardo-diffusion-xl',
      'leonardo-kino-xl',
      'leonardo-lightning-xl',
      'photoreal-v2',
    ],
    default_model: 'leonardo-phoenix',
  },

  stability: {
    available_models: [
      'stable-diffusion-3.5-large',
      'stable-diffusion-3.5-large-turbo',
      'stable-diffusion-3.5-medium',
      'stable-diffusion-3-large',
      'stable-diffusion-3-large-turbo',
      'stable-diffusion-3-medium',
      'sdxl-1.0',
      'sd3-turbo',
    ],
    default_model: 'stable-diffusion-3.5-large',
  },

  replicate: {
    available_models: [
      'black-forest-labs/flux-1.1-pro',
      'black-forest-labs/flux-pro',
      'black-forest-labs/flux-schnell',
      'black-forest-labs/flux-dev',
      'stability-ai/stable-diffusion-3.5-large',
      'recraft-ai/recraft-v3',
      'ideogram-ai/ideogram-v2',
    ],
    default_model: 'black-forest-labs/flux-1.1-pro',
  },

  // ============================================================
  // VÍDEO (5 adapters)
  // ============================================================

  kling: {
    available_models: [
      'kling-v2.1-master',
      'kling-v2',
      'kling-v1.6',
      'kling-v1.5-master',
      'kling-v1.5-pro',
      'kling-v1.5',
      'kling-v1.0',
    ],
    default_model: 'kling-v2.1-master',
  },

  hailuo: {
    available_models: [
      'MiniMax-Hailuo-02',
      'minimax-video-01',
      'minimax-video-01-live',
      'hailuo-text-to-video-6s',
      'hailuo-image-to-video-6s',
    ],
    default_model: 'MiniMax-Hailuo-02',
  },

  higgsfield: {
    available_models: ['higgsfield-soul', 'higgsfield-mix', 'higgsfield-base'],
    default_model: 'higgsfield-soul',
  },

  runway: {
    available_models: ['gen-4', 'gen-3-alpha-turbo', 'gen-3-alpha', 'gen-2'],
    default_model: 'gen-3-alpha-turbo',
  },

  luma: {
    available_models: [
      'ray-2',
      'ray-flash-2',
      'ray-1.6',
      'dream-machine',
      'photon-1',
      'photon-flash-1',
    ],
    default_model: 'ray-2',
  },

  // ============================================================
  // ÁUDIO (3 adapters)
  // ============================================================

  elevenlabs: {
    available_models: [
      'eleven_v3',
      'eleven_multilingual_v2',
      'eleven_turbo_v2_5',
      'eleven_flash_v2_5',
      'eleven_flash_v2',
      'eleven_turbo_v2',
      'eleven_monolingual_v1',
      'eleven_english_sts_v2',
      'eleven_multilingual_sts_v2',
    ],
    default_model: 'eleven_multilingual_v2',
  },

  'openai-tts': {
    available_models: [
      'tts-1',
      'tts-1-hd',
      'gpt-4o-mini-tts',
    ],
    default_model: 'tts-1-hd',
  },

  playht: {
    available_models: [
      'PlayDialog',
      'PlayHT2.0-turbo',
      'PlayHT2.0',
      'PlayHT3.0',
    ],
    default_model: 'PlayHT2.0-turbo',
  },
};

export function getPreset(name) {
  return ADAPTER_PRESETS[name] || null;
}

// Returns the model list for any adapter, falling back to empty array.
export function getModelOptions(name) {
  const preset = ADAPTER_PRESETS[name];
  return preset ? preset.available_models : [];
}
